module.exports = __webpack_public_path__ + "img/fi-rr-lasso.5ef0a775.svg";